import { Box, Grid2 as Grid, IconButton, Tooltip, Typography } from "@mui/material";
import { handleUploadFiles } from "../../../../redux/user-slices/chat.slice";
import { BASEURI, headers } from "../../../../utils/helper";
import axios from "axios";
import { chatSchema } from "../../../../utils/velidations";
import { useDispatch, useSelector } from "react-redux";
import InputFieldB from "../../../ui/InputFieldB";
import { useEffect, useMemo, useRef, useState } from "react";
import Icons from "../../../../assets/js/Icons";
import Preview from "./files/preview";
import moment from "moment";
import "moment-timezone";
import z from "zod";
import { playSendMessageSound } from "../../../../utils/sound.utils";

const title = "Kindly do not share any personal information like phone no., address, email address, Etc. Any violation of this might lead to account deactivation."

function FooterApt({ availability, isAppointmentChat = false }) {
  const files = useRef([]);
  const input = useRef(null);
  const container = useRef(null);
  const dispatch = useDispatch();
  const [error, setError] = useState("");
  const [previews, setPreviews] = useState([]);
  const { member, specialist } = useSelector((state) => state.authSlice);
  const { socket, chat, appointmentAvailability } = useSelector((state) => state.socketSlice);
  const handleSubmit = async (e) => {
    e.preventDefault()
    const form = new FormData(e.target);
    const formData = Object.fromEntries(form);
    let uploadedFiles = null, type = "text"
    if (files?.current?.length) {
      type = "file"
      const { files: data } = await dispatch(handleUploadFiles({
        files: files.current,
        receiver: chat?.user?._id,
      })).unwrap() || {}
      if (data) uploadedFiles = data
    }

    if (!uploadedFiles && !formData?.text?.trim()) return
    if (uploadedFiles && formData?.text?.trim()) { type = "both" }

    if (formData?.text?.trim()) {
      const x = chatSchema.safeParse(formData)
      if (!x.success) {
        const { fieldErrors } = z.flattenError(x?.error)
        return setError(fieldErrors?.text?.at(0))
      }
    }
    setError("")
    playSendMessageSound()

    if (isAppointmentChat) {
      try {
        await axios.post(`${BASEURI}/user/appointment-chat/send`, {
          type,
          roomId: chat?._id,
          text: formData?.text,
          receiverId: chat?.user?._id,
          files: uploadedFiles || undefined,
          sender: (member?._id || specialist?.specialist?._id || specialist?._id),
        }, {
          headers: headers()
        });
      } catch (error) {
        console.error("Error sending appointment message via REST API:", error);
      }
    } else {
      socket.emit("send-message", {
        type,
        roomId: chat?._id,
        text: formData?.text,
        receiverId: chat?.user?._id,
        files: uploadedFiles || undefined,
        sender: (member?._id || specialist?.specialist?._id || specialist?._id),
      });
    }

    setPreviews([])
    files.current = null
    input.current.value = ""
  }


  const [nowTick, setNowTick] = useState(Date.now());
  const currentAvailability = availability || appointmentAvailability;

  const availabilityStatus = useMemo(() => {
    if (!currentAvailability?.startTime || !currentAvailability?.endTime || !currentAvailability?.timeZone) {
      return "invalid"; // or "no_appointment"
    }

    const tz = currentAvailability.timeZone;

    // Parse the UTC ISO strings and convert to local timezone
    const start = moment(currentAvailability.startTime).tz(tz);
    const end = moment(currentAvailability.endTime).tz(tz);
    const now = moment().tz(tz);

    if (now.isBefore(start)) {
      return "before";
    }
    if (now.isAfter(end)) {
      return "after";
    }
    return "during";
  }, [currentAvailability, nowTick]);

  useEffect(() => {
    if (availabilityStatus === "before") {
      const interval = setInterval(() => {
        setNowTick(Date.now());
      }, 1000);
      return () => clearInterval(interval);
    }
  }, [availabilityStatus]);



  const appStatus = chat?.appointmentStatus || chat?.appointment?.appointmentStatus;

  return (
    ["completed", "cancelled", "expired", "late_cancelled", "no_refund_cancelled"].includes(appStatus) ? (
      <Typography p={1} variant="body2" textAlign="center" fontSize={13}>
        This appointment has been ended. Chat is no longer available.
      </Typography>
    ) : chat?.appointmentStatus === "no_show_specialist" || chat?.appointment?.appointmentStatus === "no_show_specialist" ? (
      <Typography p={1} variant="body2" textAlign="center" fontSize={13}>
        This appointment has been marked as a No Show by the member because the specialist did not attend the session.
        <br />
        Chat is no longer available for this appointment.
      </Typography>
    ) : chat?.appointmentStatus === "no_show_member" || chat?.appointment?.appointmentStatus === "no_show_member" ? (
      <Typography p={1} variant="body2" textAlign="center" fontSize={13}>
        This appointment has been marked as a No Show by the specialist because the member did not attend the session.
        <br />
        Chat is no longer available for this appointment.
      </Typography>
    ) : availabilityStatus === "before" ? (
      <Typography p={1} variant="body2" textAlign="center" fontSize={13}>
        Your Appointment has been scheduled for{" "}
        {moment(currentAvailability?.startTime)
          .tz(currentAvailability?.timeZone || currentAvailability?.timezone || Intl.DateTimeFormat().resolvedOptions().timeZone)
          .format("YYYY-MM-DD hh:mm A")}
        .
        <br />
        Please come back at the scheduled time.
      </Typography>
    ) : availabilityStatus === "after" ? (
      <Typography p={1} variant="body2" textAlign="center" fontSize={13}>
        Your Appointment is closed. Please schedule another appointment to send a
        message.
      </Typography>
    ) :
      <Box position="relative">
        <Grid
          ref={container}
          container p={1}
          component="form"
          alignItems="center"
          onSubmit={handleSubmit}
          columnSpacing={1}
        >
          <Grid size="auto">
            <Preview
              files={files}
              previews={previews}
              setPreviews={setPreviews}
            />
          </Grid>
          <Grid size="grow" sx={{ ".MuiInputBase-root": { borderRadius: "30px" } }}>
            <Tooltip
              title={error}
              open={Boolean(error)}
              placement="top-start"
              slotProps={{
                tooltip: {
                  sx: {
                    fontSize: 12.75,
                    color: "red.400",
                    border: "1px solid",
                    borderColor: "red.200",
                    backgroundColor: "red.50",
                    maxWidth: { xs: 500, xl: (container?.current?.clientWidth || 0) },
                  }
                }
              }}
            >
              <InputFieldB
                hiddenLabel
                name="text"
                inputRef={input}
                variant="filled"
                labelvariant="InputLabelA"
                placeholder="Write message here.."
                slotProps={{
                  input: {
                    startAdornment:
                      <Tooltip
                        title={title}
                        placement="top-start"
                        slotProps={{
                          tooltip: {
                            sx: {
                              fontSize: 12.75,
                              color: "red.400",
                              border: "1px solid",
                              borderColor: "red.200",
                              backgroundColor: "red.50",
                              maxWidth: { xs: 500, xl: (container?.current?.clientWidth || 0) },
                            }
                          }
                        }}
                      >
                        <IconButton
                          sx={{
                            fontSize: 16,
                            bgcolor: "red.300",
                            ":hover": { bgcolor: "red.400", },
                            mr: 0.5,
                            color: "white",
                            p: 0.25,
                            svg: { display: "block" }
                          }}
                        >
                          <Icons.Alert />
                        </IconButton>
                      </Tooltip>
                  }
                }}
              />
            </Tooltip>
          </Grid>
          <Grid size="auto">
            <IconButton
              size="small"
              type="submit"
              sx={{ "svg": { fontSize: 22 } }}
            ><Icons.SentPlane />
            </IconButton>
          </Grid>
        </Grid>
      </Box>
  )
}

export default FooterApt